/* global fbq */
import { castArray } from 'lodash';
import config from '../../../config';

const FB_EVENTS_SCRIPT = 'https://connect.facebook.net/en_US/fbevents.js';
const FB_EXTENSIONS_SCRIPT = 'https://connect.facebook.net/en_US/platform.Extensions.js';

export default class FBPixel {
  static fbEventsInitialized = false;
  static extensionsLoaded = false;
  static extensionsInitialized = false;
  static consent = false;
  static loadedPixels = new Map();

  static init(loadExtensions = false) {
    if (!this.fbEventsInitialized) {
      // Async load facebook pixel library
      // eslint-disable-next-line
      !function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod?  n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', FB_EVENTS_SCRIPT);
      // We will track
      fbq.disablePushState = true;
      this.setGranted(false);
      this.fbEventsInitialized = true;
    }

    if (loadExtensions) {
      this.loadExtensionsScript();
    }
  }

  static loadExtensionsScript() {
    if (!this.extensionsLoaded) {
      // Async load facebook extensions library
      // eslint-disable-next-line
      (function(d, s, id){ var js, fjs = d.getElementsByTagName(s)[0]; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = FB_EXTENSIONS_SCRIPT; fjs.parentNode.insertBefore(js, fjs); }(document, 'script', 'facebook-ixsdk'));
      this.extensionsLoaded = true;
    }
  }

  static initExtensions() {
    if (!this.extensionsInitialized) {
      window.FBExtensions.init({ appId: config.fbPixel });
      this.extensionsInitialized = true;
    }
  }

  static setGranted(granted = true) {
    if (this.fbEventsInitialized) {
      fbq('consent', granted ? 'grant' : 'revoke');
    }
  }

  static setPixelFor(context, pixelId = null) {
    if (pixelId === null) {
      if (this.loadedPixels.has(context)) {
        this.loadedPixels.delete(context);
      }
      return;
    }

    this.init();
    fbq('init', pixelId);
    this.loadedPixels.set(context, pixelId);
  }

  static trackPageView(context, customData, eventData) {
    this.track(context, 'PageView', customData, eventData);
  }

  static trackReservation(context, customData) {
    this.track(context, 'Reservation', customData);
  }

  static trackSchedule(context) {
    this.track(context, 'Schedule');
  }

  static track(context, eventName, customData, eventData) {
    this.init();
    const identifiers = castArray(context);
    for (let i = 0; i < identifiers.length; i += 1) {
      const pixelId = this.loadedPixels.get(identifiers[i]);
      if (pixelId) {
        fbq('trackSingle', pixelId, eventName, customData, eventData);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/fbPixel.js